import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DeviceFiles, FileApi } from 'src/api/file.api';

@Injectable()
export class DeviceFilesService {
  private readonly fileApi = inject(FileApi);


  public getDeviceFilesByMachineId$(id: string): Observable<DeviceFiles> {
    return this.fileApi.getDeviceFilesByMachineId$(id);
  }
}
